export enum FOCUSED_FEATURE_SHELL_VARIANT {
  FEATURE = 'feature',
  INTERRUPT = 'interrupt',
}
